import { render, staticRenderFns } from "./viewDoc.vue?vue&type=template&id=c475a2fe&scoped=true&"
import script from "./viewDoc.vue?vue&type=script&lang=js&"
export * from "./viewDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c475a2fe",
  null
  
)

export default component.exports